
import {
  ArrowDown,
  ArrowUp,
  Calendar,
  CheckSquare,
  DollarSign,
} from "lucide-react";
import React, { useEffect, useState } from "react";

const PaymentHistrory = ({ paymentHistryData, BookingData }) => {
  const [showFullID, setShowFullID] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(paymentHistryData);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const formatDateMMDDYYYY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    });
  };

  const totalPaid = paymentHistryData.reduce(
    (total, payment) => total + payment.ledger_price,
    0
  );

  const highestPayment = Math.max(
    ...paymentHistryData.map((payment) => payment.ledger_price)
  );

  const completedPaymentsCount = paymentHistryData.filter(
    (payment) => !["Failed", "Card"].includes(payment.status)
  ).length;

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // reset to first page
  };

  const filtered = paymentHistryData.filter(
    (payment) => payment.refund_status == 0
  );
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <div className="payments-tab">
        <div className="tab-header">
          <h3>Payment History</h3>
        </div>

        <div className="maintenancecard-container">
          {/* Total Amount Card with Hover Detail */}
          <div className="maintenancecard-item relative">
            <div className="maintenancecard-header relative">
              <span className="maintenancecard-label">Total Amount</span>
              <span className="maintenancecard-value">
                ${BookingData.total_amount}
              </span>

              {/* Hover Detail Card - Only visible when hovering this card */}
              <div className="detailcard-hover">
                <h5 className="detailcard-hover-title">Details</h5>
                <div className="detailcard-hover-row">
                  <span className="detailcard-hover-label">Total Discount</span>
                  <span className="detailcard-hover-value">
                    ${BookingData.total_discount.toFixed(2) || '0.00'}
                  </span>
                </div>
                <div className="detailcard-hover-row">
                  <span className="detailcard-hover-label">Balance Discount</span>
                  <span className="detailcard-hover-value positive">
                  ${BookingData.balance_discount.toFixed(2) || '0.00'}
                  </span>
                </div>
                <div className="detailcard-hover-row">
                  <span className="detailcard-hover-label">Rent Advance</span>
                  <span className="detailcard-hover-value positive">
                    ${BookingData.balance_advance.toFixed(2) || '0.00'}
                  </span>
                </div>
                <div className="detailcard-hover-row">
                  <span className="detailcard-hover-label">Refund</span>
                  <span className="detailcard-hover-value positive">
                    ${BookingData.refund_amount.toFixed(2) || '0.00'}
                  </span>
                </div>
              </div>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.total_due}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Rent Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Rent</span>
              <span className="maintenancecard-value">
                ${BookingData.total_rent}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_rent}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Deposit Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Deposit</span>
              <span className="maintenancecard-value">
                ${BookingData.total_deposit || '0.00'}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_deposit || '0.00'}
                  </span>
                </div>
              </div>
            </div>
          </div>

       
          {/* Tolls Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Tolls</span>
              <span className="maintenancecard-value">
                ${BookingData.total_tolls}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_tolls}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Damage Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Damage</span>
              <span className="maintenancecard-value">
                ${BookingData.total_damagefees}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_damage}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Tickets Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Tickets</span>
              <span className="maintenancecard-value">
                ${BookingData.total_tickets}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_ticket}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Other Charges Card */}
          <div className="maintenancecard-item">
            <div className="maintenancecard-header">
              <span className="maintenancecard-label">Other Charges</span>
              <span className="maintenancecard-value">
                ${BookingData.total_other_charges}
              </span>
            </div>
            <div className="maintenancecard-footer">
              <div className="maintenancecard-status">
                <div className="maintenancecard-due">
                  <span className="maintenancecard-label-small">Due</span>
                  <span className="maintenancecard-due-amount">
                    ${BookingData.due_other_charges}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table-container">
          <table className="data-table payments-table">
            <thead>
              <tr>
                <th>
                  <div className="th-content">
                    <span>Sr.No.</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="th-content" >
                    <span style={{marginLeft:'30px'}}>Date</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <span>Payment Id</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <span>Payment Description</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <span>Amount</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="th-content">
                    <span>Payment Mode</span>
                    <div className="sort-icons">
                      <ArrowUp className="sort-icon" />
                      <ArrowDown className="sort-icon" />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData
                  .filter((payment) => payment.refund_status == 0)
                  .map((payment, index) => (
                    <tr key={index} className="data-row">
                      <td>
                        <div className="id-cell">
                          #{(currentPage - 1) * itemsPerPage + index + 1}
                        </div>
                      </td>
                      <td>
                        <div className="date-cell">
                          <Calendar className="cell-icon" />
                          {formatDateMMDDYYYY(payment.payment_date)}
                        </div>
                      </td>
                      <td>
                        <div className="amount-cell">
                          {payment.transaction_id}
                        </div>
                      </td>
                      <td>
                        <div className="amount-cell">
                          {payment.transaction_note}
                        </div>
                      </td>
                      <td>
                        <div className="amount-cell">
                          ${payment.total_amount}
                        </div>
                      </td>
                      <td>
                        <div className="payment-mode-cell">
                          <span
                            className={`payment-mode ${payment.payment_mode}`}
                          >
                            {payment?.payment_mode}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No matching payment records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <div className="pagination">
            <button
              className="pagination-btn prev"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <div className="pagination-pages">
              {[...Array(totalPages)].map((_, idx) => (
                <button
                  key={idx}
                  className={`pagination-page ${
                    currentPage === idx + 1 ? "active" : ""
                  }`}
                  onClick={() => handlePageClick(idx + 1)}
                >
                  {idx + 1}
                </button>
              ))}
            </div>

            <button
              className="pagination-btn next"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
          <div className="items-per-page">
            <span>Show:</span>
            <select
              className="items-select"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
            <span>items</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentHistrory;